import { useEffect } from 'react';
import { useApiError } from '../../../hooks/useApiError';
import { initApiErrorService } from '../../../services/apiErrorService';

const ApiErrorInitializer = ({ children }) => {
  const { showError } = useApiError();

  useEffect(() => {
    // Initialize the API error service with the context function
    initApiErrorService(showError);
    
    return () => {
      // Cleanup on unmount
      initApiErrorService(null);
    };
  }, [showError]);

  return children;
};

export default ApiErrorInitializer;